module.exports = __webpack_public_path__ + "images/greenlab-7c0fa143011403ce3562665ed081137c.jpg";